export const ACTIVE = 'active';
export const DECLINED = 'declined';
export const PENDING = 'pending';
export const INACTIVE = 'inactive';
export const DECLINE = 'decline';
export const EDIT = 'edit';
export const APPROVED = 'approved';
export const CANCELLED = 'cancelled';
export const ACCEPTED = 'accepted';
export const DELETED = 'deleted';
export const EMAIL_VERIFIED = 'email_verified';
export const ONDATO_REJECTED = 'ondato_rejected';
export const UNVERIFIED = 'unverified';
export const RESOLVED = 'resolved';

export const STATUS_COLORS = {
  [ACTIVE]: 'success',
  [ACCEPTED]: 'success',
  [RESOLVED]: 'success',
  [APPROVED]: 'success',
  [EMAIL_VERIFIED]: "success",
  [DECLINED]: 'error',
  [DECLINED]: 'error',
  [PENDING]: "warning",
  [UNVERIFIED]: "warning",
  [INACTIVE]: 'error',
  [DELETED]: "error",
  [CANCELLED]: "error",
  [ONDATO_REJECTED]: "error",
};

export const AUTO_LOGOUT_STATUS = Object.freeze([
  ONDATO_REJECTED,
  UNVERIFIED,
  EMAIL_VERIFIED,
  DECLINED,
  DELETED,
]);

// Sync this with the backend enum
// src\app\Enums\CollabRequestEnums.php
export const COLLAB_REQUEST_STATUS = Object.freeze({
  PENDING,
  CANCELLED,
  ACCEPTED,
  DECLINED,
});

export const USER_STATUS = Object.freeze({
  ACTIVE,
  DECLINED,
  PENDING,
  DELETED,
  EMAIL_VERIFIED,
  ONDATO_REJECTED,
  UNVERIFIED
});
